export const RESULT_SEGMENTS = [
	{ key: "", label: "All", tone: "neutral" },
	{ key: "needs_decisions", label: "Needs decisions", tone: "warning" },
	{ key: "waiting_on_signoff", label: "Waiting on sign-off", tone: "accent" },
	{ key: "done", label: "Done", tone: "success" },
	{ key: "no_action", label: "No action needed", tone: "success" },
	{ key: "worth_a_look", label: "Worth a look", tone: "warning" },
	{ key: "did_not_finish", label: "Didn't finish", tone: "danger" },
	{ key: "skipped", label: "Skipped", tone: "neutral" },
	{ key: "in_progress", label: "In progress", tone: "accent" },
];

export const STARTED_CHOICES = [
	{ value: "", label: "Any time" },
	{ value: "today", label: "Today" },
	{ value: "last_7_days", label: "Last 7 days" },
	{ value: "last_30_days", label: "Last 30 days" },
	{ value: "this_month", label: "This month" },
	{ value: "last_month", label: "Last month" },
	{ value: "custom", label: "Custom range…" },
];

export const FINDINGS_CHOICES = [
	{ value: "", label: "Any findings" },
	{ value: "high", label: "Has high" },
	{ value: "medium_or_high", label: "Has high or medium" },
];

export const VIEW_CHOICES = [
	{ value: "latest", label: "Latest run per client" },
	{ value: "all", label: "Every run" },
];
